import { getPlatform, isNativePlatform } from "./platformUtil";

export type BrowserKey =
  | "chrome-desktop"
  | "safari-mac"
  | "chrome-android"
  | "chrome-ios"
  | "safari-ios"
  | "firefox"
  | "android"
  | "ios"
  | "unknown";

export const BrowserLabel: Record<BrowserKey, string> = {
  "chrome-desktop": "Chrome (Desktop)",
  "safari-mac": "Safari (macOS)",
  "chrome-android": "Chrome (Android)",
  "chrome-ios": "Chrome (iOS)",
  "safari-ios": "Safari (iOS)",
  "firefox": "Firefox",
  "android": "Influns App (Android)",
  "ios": "Influns App (iOS)",
  "unknown": "Your Browser/App",
};

export function detectBrowser(): BrowserKey {
  // First check if running inside Capacitor app
  if (isNativePlatform()) {
    const platform = getPlatform(); // "ios" | "android"
    if (platform === "android") return "android";
    if (platform === "ios") return "ios";
  }

  const ua = navigator.userAgent;

  // Android Chrome
  if (/Android/i.test(ua) && /Chrome/i.test(ua)) return "chrome-android";

  // iOS Chrome
  if (/iPhone|iPad|iPod/i.test(ua) && /CriOS/i.test(ua)) return "chrome-ios";

  // iOS Safari
  if (/iPhone|iPad|iPod/i.test(ua) && /Safari/i.test(ua) && !/CriOS/i.test(ua))
    return "safari-ios";

  // macOS Safari
  if (/Macintosh/i.test(ua) && /Safari/i.test(ua) && !/Chrome/i.test(ua))
    return "safari-mac";

  // Chrome desktop
  if (/Chrome/i.test(ua) && !/Edg/i.test(ua) && !/OPR/i.test(ua))
    return "chrome-desktop";

  // Firefox
  if (/Firefox/i.test(ua)) return "firefox";

  return "unknown";
}
